module.exports = __webpack_public_path__ + "static/img/1.050d924.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/1.png
// module id = uHkW
// module chunks = 0